import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import { Offline, Online } from "react-detect-offline";
import { withOneTabEnforcer } from "react-one-tab-enforcer"

import { Icon, TransitionablePortal, Segment, List, Transition, Dimmer } from 'semantic-ui-react';
import { history } from './helpers';

import PrivateRoute from './components/common/PrivateRoute';

import { Login } from './components/login/Login';
import { Invite } from './components/login/Invite';
import ForgotPassword from './components/login/ForgotPassword';
// import SignUpComponent from './components/login/SignUpComponent.jsx';
import { SignUp } from './components/login/SignUp.jsx';
import VerifyComponent from './components/login/VerifyComponent';


import { SSOPage } from './components/login/SSOPage';
import { SSOSuccess } from './components/login/SSOSuccess'

import PageShell from './components/login/PageShell';
import ResetPassword from './components/login/ResetPassword';
import { PricingPage } from './components/staticweb/PricingPage';
import { OrderSuccessPage } from './components/staticweb/OrderSuccessPage';
import TermsPage from './components/staticweb/TermsPage';

import { Home } from './components/layout';
import NoMobileSupport from './components/layout/NoMobileSupport';
import { ActiveUserLogin } from './components/login/ActiveUserLogin';
import { UpdatePassword } from './components/login/UpdatePassword';
import { SetupCredentials } from './components/login/SetupCredentials';
import { UnsubscribeEmail } from './components/login/EmailUnsubscription';
import { PrintViewPage } from './components/workspace/commanderDashboard/components/PrintView.jsx';

import NotFound from './components/common/NotFound'
import NoAssociatedAccounts from './components/common/NoAssociatedAccounts';
import { Auth } from './components/login/Auth.jsx';
import { CreateWorkspace } from './components/common/CreateWorkspace.jsx';
import { CreateAccount } from './components/common/CreateAccount.jsx';
import { MicrosoftAuth } from './components/login/MicrosoftAuth.jsx';
import { EmailVerified } from './components/login/EmailVerified';

let server_url = process.env.REACT_APP_SERVER_URL;

if (!server_url || server_url === "") {
  server_url = `${window.location.protocol}//${window.location.hostname}`;
  if (window.location.port !== "") {
    server_url = `${server_url}:${window.location.port}`;
  }
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      animation: "fade left",
      width: window.innerWidth,
      duration: 1000,
      isOnline: false
    }
  }

  componentWillMount() {
    if(history.location.pathname === "/") {
      history.push("/login")
    }
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  handleWindowSizeChange = () => {
    if (window.innerWidth !== this.state.width) {
      this.setState({ width: window.innerWidth });
    }
  };

  isOnline = () => {
    this.setState({ isOnline: true })
  }

  isOffline = () => {
    this.setState({ isOnline: false })
  }

  render() {
    const {
      animation,
      duration,
      width
    } = this.state

    const isMobile = width <= 1024;
    let offlineCheckUrl = "www.google.com/";

    const LOCAL_DOMAINS = ["localhost", "127.0.0.1"];
    if (!LOCAL_DOMAINS.includes(window.location.hostname)) {
      let url = `${window.location.protocol}//${window.location.hostname}`;
      if (window.location.port !== "") {
        url = `${url}:${window.location.port}`;
      }
      offlineCheckUrl = `${url}/favicon.ico`;
    }
    const pollingConfig = {
      url: offlineCheckUrl,
    }

    if (isMobile) {
      return (
        <div>
          <Router history={history}>
            <Switch>
              <Route exact path="/invite/:id" component={PageShell(Invite)} />
              <Route exact path="/success" component={OrderSuccessPage} />
              <Route exact path="/setupcredentials" component={PageShell(SetupCredentials)} />
              <Route exact path="/updatePassword/:userid" component={PageShell(UpdatePassword)} />
              <Route exact path="/email-verified/:userid/:otp" component={PageShell(EmailVerified)} />
              <Route path="/" component={NoMobileSupport} />
            </Switch>
          </Router>
        </div>
      );
    } else {
      return (
        <div>
          <Online onChange={this.isOnline} polling={pollingConfig}>
            <TransitionablePortal open={this.state.isOnline} transition={{ animation, duration }}>
              <Segment style={{ right: '20px', position: 'fixed', bottom: '20px', zIndex: 1000, background: "#41A75E", color: "white" }}>
                <List><List.Item> <Icon name='check' /> Connected </List.Item> </List>
              </Segment>
            </TransitionablePortal>
          </Online>

          <Offline onChange={this.isOffline} polling={pollingConfig}>
            {window.location.hostname !== "localhost" ?
              <Dimmer className="noInternerDimmer" active={true} blurring={"true"} inverted page></Dimmer>
              :
              null
            }

            <div style={{ right: '20px', position: 'fixed', bottom: '20px', zIndex: 1001, background: "#EB6B56", color: "white", padding: "1em", borderRadius: ".28571429rem" }}>
              <Transition visible={true} animation='scale' duration={500}>
                <List>  <List.Item> <Icon name='exclamation triangle' /> You are currently Offline</List.Item></List>
              </Transition>
            </div>
          </Offline>

          <Router history={history}>
            <div className="App">
              <Route exact path="/" component={PricingPage} ></Route>
              <Route exact path="/success" component={OrderSuccessPage} ></Route>
              <Route exact path="/terms" component={TermsPage} ></Route>
              <Route exact path="/sso/:id" component={SSOPage} ></Route>
              <Route exact path="/ssosuccess" component={SSOSuccess} ></Route>
              <Route path="/login" exact component={PageShell(Login)}></Route>
              <Route path="/auth/callback" exact component={PageShell(Auth)}></Route>
              <Route path="/auth/callback/microsoft" exact component={PageShell(MicrosoftAuth)}></Route>
              <Route path="/invite/:id" exact component={PageShell(Invite)}></Route>
              <Route path="/forgotpassword" exact component={PageShell(ForgotPassword)}></Route>
              {/* <Route path="/newaccount" exact component={SignUpComponent} /> */}
              <Route path="/newaccount" exact component={PageShell(SignUp)}></Route>
              <Route path="/register" exact component={PageShell(SignUp)}></Route>
              <Route path="/signup" exact component={PageShell(SignUp)}></Route>
              <Route path="/createaccount" exact component={PageShell(SignUp)}></Route>
              <Route path="/verify" exact component={PageShell(VerifyComponent)}></Route>
              <Route path="/resetpassword/:userid/:otp" exact component={PageShell(ResetPassword)}></Route>
              <Route path="/email-verified/:userid/:otp" exact component={PageShell(EmailVerified)}></Route>
              <Route path="/activeuserlogin/:userid" exact component={PageShell(ActiveUserLogin)}></Route>
              <Route path="/updatePassword/:userid" exact component={PageShell(UpdatePassword)}></Route>
              <Route path="/setupcredentials" exact component={PageShell(SetupCredentials)}></Route>
              <Route path="/invite/404" exact component={PageShell(NotFound)} />
              <Route path="/newuser/:useremail" component={PageShell(NoAssociatedAccounts)}></Route>
              <Route path="/createWorkspace/:accountId" component={PageShell(CreateWorkspace)}></Route>
              <Route path="/createAccount/:useremail" component={PageShell(CreateAccount)}></Route>
              <Route path="/email/unsubscribe/:userId/:entityName/:entityId" component={PageShell(UnsubscribeEmail)}></Route>
              <PrivateRoute path="/app" component={Home} />
              <PrivateRoute path="/printdashboard/:dashboardId" component={PrintViewPage} />
              <ReduxToastr
                timeOut={3000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar
              />
            </div>
          </Router>
        </div>);
    }

  }
}

export default App;


